let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("gUDrR")).then(() => parcelRequire('aHUj9'));